export const APP_VERSION = '0.37.18-20261020-1633'
